export const SaveZSYNCIO = async (dataJson: any) => {
  const respone = await fetch("api/InternalOrder/SaveInternalOrder", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZSYNCIOs: Array.isArray(dataJson) ? dataJson : [dataJson],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  return respone;
};
